export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/NoArtifactCardAsset-86c12be96f35ab20ea9d8b6f8239986d.jpg";